import { Component, ViewEncapsulation, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService, EventManager } from 'src/app/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Dispatcher, StoreInfoUser, StoreResource } from './state';
import { DateUtil } from './shared/util/date.util';
import { ThemeService } from './shared/services/theme.service';
import { FileSaverService } from 'ngx-filesaver';
declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'admin-fmarket';
  spinner: number = 0;
  isShowSpinner = false;
  theme: string = 'default';
  constructor(
    private translate: TranslateService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private cdf: ChangeDetectorRef,
    private localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private accountService: AccountService,
    private dispatcher: Dispatcher,
    private toast: ToastrService,
    public fileSaverService: FileSaverService,
    private themeService: ThemeService,
    private eventManager: EventManager) {
      translate.addLangs(['en_US', 'vi_VN']);
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('vi_VN');
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('vi_VN');
    }
  ngOnInit() {
    this.changeTheme('primary');
    this.eventManager.subscribe('show-spinner', (res) => {
      // this.spinnerService.show();
      console.log('show spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      this.isShowSpinner = true;
      this.cdf.detectChanges();
    });
    this.eventManager.subscribe('close-spinner', (res) => {
      // this.spinnerService.hide();
      console.log('hide spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      this.isShowSpinner = false;
      this.cdf.detectChanges();
    });
    this.eventManager.subscribe('Fmarket.authenError' , (content) => {
      this.router.navigate(['/authentication/login']);
    });
    this.eventManager.subscribe('Fmarket.httpError' , (content) => {
      if (content.message || content.content) {
        this.toast.error('Error: ', content.message || content.content || 'Error happen');
      }
    });
    this.eventManager.subscribe('change-theme' , (res) => {
      this.changeTheme(res.content.theme);
    });
    const token = this.$sessionStorage.retrieve('token');
    if (token) {
      this.dispatcher.fire(new StoreResource());
      const profile = this.$sessionStorage.retrieve('profile');
      this.dispatcher.fire(new StoreInfoUser(profile));
      this.accountService.authenticate(profile);
    }
    this.eventManager.subscribe('export-file' , (res) => {
      this.exportFile(res.content);
    });
    this.initIgnorepis();
  }
  ngAfterViewInit(): void {
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });
  }
  initIgnorepis() {
    const ignoreAPIS = [
      'vi_VN.json',
      'res/all',
      'stats/ga-stats',
      'stats/statistics-infos',
      'stats/partner-stats',
      'stats/balance-infos',
      'stats/users-stats',
      'stats/product-stats',
      'stats/users-by-order-stats',
      'stats/orders-stats',
      'stats/sms-balance',
      'stats/introduce-program-stats',
      'stats/goal-companion-stats',
      'stats/gold-stats',
      'stats/smart-portfolio-stats',
      '/admin/api/active-product'
    ];
    sessionStorage.setItem('ignoreAPIS', JSON.stringify(ignoreAPIS));
  }
  changeTheme(theme) {
    theme = theme || 'default';
    this.theme = theme;
    this.localStorage.store('theme', theme);
    this.themeService.changeTheme(theme);
  }
  exportFile(res) {
    let disposition = res.headers.get('content-disposition');
    disposition = disposition || 'filename'; 
    let filename = disposition.split('filename')[1] || 'file';
    filename = filename.replaceAll('\"', '');
    filename = filename.replaceAll('\=', '');
    this.fileSaverService.save(res.body, filename);    
    
    // const blob = new Blob([res.body], {type: 'text/xls'});
    // const downloadUrl = URL.createObjectURL(blob);
    // const a: any = document.createElement("a");
    // document.body.appendChild(a);
    // a.style = "display: none";
    // a.href = downloadUrl;
    // let disposition = res.headers.get('content-disposition');
    // disposition = disposition || 'filename'; 
    // let filename = disposition.split('filename')[1] || 'file';
    // filename = filename.replaceAll('\"', '');
    // filename = filename.replaceAll('\=', '');
    // a.download = filename;
    // a.click();
    // window.URL.revokeObjectURL(downloadUrl);
  }
}
